exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon[data-v-2065c6dc]{opacity:0.6}.icon[data-v-2065c6dc]:hover,.icon[data-v-2065c6dc]:focus{background-color:#f2f2f2;opacity:1}.right-icons[data-v-2065c6dc]{float:right}.header-placeholder[data-v-2065c6dc]{height:54px}.links[data-v-2065c6dc]{text-decoration:underline}@media (max-width: 767px){.row.middle-xs[data-v-2065c6dc]{margin:0 -15px}.row.middle-xs.py5[data-v-2065c6dc]{margin:0}.col-xs-2[data-v-2065c6dc]:first-of-type{padding-left:0}.col-xs-2[data-v-2065c6dc]:last-of-type{padding-right:0}a[data-v-2065c6dc],span[data-v-2065c6dc]{font-size:12px}}\n", ""]);

// exports
